/* -------------------------------------------------------------------------- */
/*                      // Custom dropdown via choices.js                     */
/* -------------------------------------------------------------------------- */
const variantSelect = document.getElementById('select-variant');
if (variantSelect.type == 'select-one') {
    const choices = new Choices(variantSelect, {
        choices: getOptions(variantSelect),
        searchEnabled: false,
        itemSelectText: null,
        allowHTML: true,
        shouldSort: false,
        labelId: 'select-variant-label'
        // callbackOnInit: () => {
        //     [...document.querySelectorAll('.choices__list--dropdown .choices__item')].forEach(elem => {
        //     })
        // }
    });
}
function getOptions(selectElement) {
    const items = [];

    let selectOptions = Array.from(selectElement.children);
    selectElement.innerHTML = '';

    selectOptions.forEach((option) => {
        let label = option.dataset.title || option.innerHTML;

        const available = option.dataset.available;
        let isAvailable = true; // default to true if no info

        // Apply strikethrough if unavailable
        if (available !== undefined && available !== null) {
            isAvailable = available.toLowerCase() === 'true';
        }

        if (!isAvailable) {
            label = `<span><s>${label}</s> (out of stock)</span>`;
        }

        // Add image
        if (option.dataset.swatch) {
            label = `<img src="${option.dataset.swatch}" width="30" class="variant-swatch">` + label;
        }

        // Add wrapper with availability class if known
        const availabilityClass = (available !== undefined)
            ? ' ' + (isAvailable ? 'available' : 'unavailable')
            : '';

        label = `<div class="option${availabilityClass}">${label}</div>`;





        items.push({
            value: option.value,
            label: label,
            selected: option.hasAttribute('selected'),
            disabled: option.hasAttribute('disabled'),
            placeholder: option.hasAttribute('placeholder'),
            class: 'yolo'

        });
    })

    return items;
}

function selectStyle() {
    if (variantSelect) {
        variantSelect.click();
    }
}


/* -------------------------------------------------------------------------- */
/*                              Availability Box                              */
/* -------------------------------------------------------------------------- */


function updateProductAvailibility() {
    const qtyInput = document.getElementById('quantity');
    const availBox = document.querySelector('.availibility-box');

    if (!availBox) { return; }

    const availableQty = Number(availBox.dataset.quantityBreak);
    if (isNaN(availableQty)) return;

    if (!qtyInput) return;

    const qty = Number(qtyInput.value);
    if (isNaN(qty)) return;

    const underQty = availBox.querySelector('.under-qty');
    const overQty = availBox.querySelector('.over-qty');

    if (qty <= availableQty) {
        if (underQty) underQty.style.display = 'block';
        if (overQty) overQty.style.display = 'none';
    } else {
        if (underQty) underQty.style.display = 'none';
        if (overQty) overQty.style.display = 'block';
    }
}

// Setup
(() => {
    const qtyInput = document.getElementById('quantity');
    qtyInput.addEventListener('change', updateProductAvailibility);
    qtyInput.addEventListener('input', updateProductAvailibility);
    updateProductAvailibility();
})();



/* -------------------------------------------------------------------------- */
/*                            // Variant switching                            */
/* -------------------------------------------------------------------------- */

function variantSwitchCallback(e = null) {
    if (!variantSelect) { return; }
    const selectedVariantId = variantSelect.value;
    const selectedVariant = product.variants.find(v => v.id == selectedVariantId);

    variantSelect.dispatchEvent(
        new CustomEvent('variantChange', {
            detail: {
                variant: selectedVariant
            },
            bubbles: true
        })
    );

    // Update Quantity Input Limits
    updateQtyInputLimits(selectedVariant);



    if (variantSelect.type == 'select-one') {

        document.querySelector(`.product-images__thumbnail.active-variant`)?.classList.remove('active-variant');

        // Switch Image
        let imageId = selectedVariant.featured_image?.id;
        if (!imageId) {
            document.querySelector(`.product-images__thumbnail`).click();
        } else {
            const imageThumb = document.querySelector(`.product-images__thumbnail[data-image-id="${imageId}"]`);
            if (imageThumb) {
                imageThumb.click();
                imageThumb.classList.add('active-variant');
            }
        }
    }

    // Load variant details
    updateSections(['product-info', 'product-details', 'product-actions'], `products/${product.handle}`, { variant: selectedVariantId }).then(() => {
        updateProductAvailibility();
    });



    // Update classes (reveals upsells)
    if (selectedVariant.available) {
        document.querySelector('.product-form')?.classList.add('option-selected');
    } else {
        document.querySelector('.product-form')?.classList.remove('option-selected');

    }

    // Update the URL parameter
    const url = new URL(window.location.href);
    url.searchParams.set('variant', selectedVariantId);

    // Use pushState to update the URL
    window.history.replaceState({ path: url.href }, '', url.href);

    // Update analytics
    Shopify.analytics.publish('product_viewed', {
        productVariant: {
            id: selectedVariant.id,
            title: product.title + ' - ' + selectedVariant.title,
            price: { amount: selectedVariant.price / 100, currencyCode: Shopify.currency.active },
            product: { id: product.id, title: product.title }
        }
    });



}

if (variantSelect) {
    variantSelect.addEventListener('change', variantSwitchCallback);
}

/* -------------------------------------------------------------------------- */
/*                            Quantity Input Limits                           */
/* -------------------------------------------------------------------------- */

function updateQtyInputLimits(variant) {
    const qtyInput = document.getElementById('quantity');

    // Update qty box custom limits
    if (variant.special_order_minimum && variant.special_order_minimum > variant.display_quantity) {
        qtyInput?.__instance?.setCustomInvalidRange(variant.display_quantity, variant.special_order_minimum);
    } else {
        qtyInput?.__instance?.clearCustomInvalidRange();
    }
}

// Init if there is a current variant on load (passed from URL etc)
if (product.current_variant) {
    updateQtyInputLimits(product.variants.find(v => v.id == product.current_variant));
}

/* -------------------------------------------------------------------------- */
/*                              Ajax cart button                              */
/* -------------------------------------------------------------------------- */
const productForm = document.querySelector('.shopify-product-form');
//button.addEventListener('click', function (e) {

productForm.addEventListener('submit', addToCart);


function addToCart(e) {
    e.preventDefault();

    const cartForm = e.target.closest('form');
    const button = e.submitter;
    //document.querySelector('.add-to-cart');

    const formID = cartForm.getAttribute('id');

    postAddToCartModal.load();

    const buttonContents = button.textContent;
    button.innerHTML = `<span class="spinner">Loading...</span>`;
    button.disabled = true;

    const formData = serialiseForm(cartForm);

    const properties = {};
    Object.entries(formData).forEach(([key, value]) => {
        const match = key.match(/^properties\[(.*)\]$/);
        if (match) {
            const propertyName = match[1];
            properties[propertyName] = value;
        }
    });
    const postData = {};
    postData['items'] = [
        {
            id: formData.id,
            quantity: formData.quantity
        }
    ];
    postData['sections'] = "cart-bubble";

    if (Object.keys(properties).length > 0) {
        postData['items'][0]['properties'] = properties;
    }

    // Matching thread + TODO: Other upsells
    if (formID.includes('product_form_')) {
        // We only want to do this on product forms (not samples)

        const matchingThread = document.querySelector('[data-matching-thread-product]');
        if (matchingThread?.checked) {
            postData.items.unshift({
                id: matchingThread.dataset.matchingThreadProduct,
                quantity: 1,
                properties: {
                    "For SKU": product.variants.find(v => v.id === formData.id)?.sku

                }

            })
        }


        // Upsells

        const upsellForm = document.getElementById('upsells');
        if (upsellForm) {
            const upsellFormData = formToObject(upsellForm);
            Object.values(upsellFormData).forEach(value => {
                if (value.checkbox && value.variant) {
                    postData.items.unshift({
                        id: value.variant,
                        quantity: 1
                    })
                }
            });
        }
    }

    fetch('/cart/add.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
        },
        body: JSON.stringify(postData)
    })
        .then(async response => {
            button.textContent = buttonContents;
            button.disabled = false;

            const data = await response.json().catch(() => undefined);

            if (!response.ok) {
                const error = new Error('Add to cart failed');
                error.responseData = data; // attach extra info
                throw error;
            }
            return data;

        })
        .then(data => {
            // Update cart count
            replaceSections(data.sections);

            if (postAddToCartModal.ready) {
                postAddToCartModal.open();
            } else {
                let checks = 16; // 16 checks * 30ms ≈ 480ms (safely under 500ms)

                const interval = setInterval(() => {
                    checks--;

                    if (postAddToCartModal.ready) {
                        clearInterval(interval);
                        postAddToCartModal.open();
                    } else if (checks === 0) {
                        clearInterval(interval);
                        // Mini-cart Fallback            
                        miniCart.open(true);
                        popupMessage('Added to Bag', 'success', 5000);
                        // data.items.forEach(item => {
                        //     document.querySelector(`#mini-cart [data-line-item-key="${item.key}"]`)?.classList.add('highlight');
                        // });
                    }
                }, 30);
            }



            // Reset upsells
            const upsells = document.querySelector('.product-upsells');
            if (upsells) {
                upsells.querySelectorAll('input[type="checkbox"]').forEach(checkbox => {
                    console.log(checkbox);
                    checkbox.checked = false;
                })
            }

        })
        .catch(error => {

            console.error('Error adding to cart:', error);
            console.error('Response JSON:', error.responseData);

            let errorMessage = error.responseData?.message;
            if (errorMessage) {
                if (errorMessage.includes('items were added to your cart due to availability.')) {
                    errorMessage = 'The maximum quantity available was added to your bag.'

                    if(postAddToCartModal.ready) {
                        postAddToCartModal.message = errorMessage;
                        postAddToCartModal.open();
                        return;
                    }
                }
                errorMessage = errorMessage.replace('cart', 'bag');
                miniCart.open();
            } else {
                errorMessage = 'There was a problem adding the item to the bag. Please check and try again';
            }
            popupMessage(errorMessage, 'error', 5000);


        });

}


/* -------------------------------------------------------------------------- */
/*                           Post Add To Cart Modal                           */
/* -------------------------------------------------------------------------- */
class PostAddToCartModal {
    constructor() {
        this.container = document.createElement('div');
        this.container.classList.add('patcm__overlay')

        this.inner = document.createElement('div');
        this.inner.id = 'post-add-to-cart-modal';
        this.inner.classList.add('patcm')

        this.ready = false;

        this.container.append(this.inner);

        console.log('PATC', 'constructed');


    }

    #initPromise = null;

    load() {
        console.log('PATC', 'loading');

        document.body.append(this.container);

        this.#initPromise = updateSections(['post-add-to-cart-modal'], product.patcm_url).then(() => {
            this.#initLayout();
            this.ready = true;
            console.log('PATC', 'loaded')
        });

        return this.#initPromise;
    }

    async open() {

        console.log('PATC', 'open call');

        if (!this.#initPromise) {
            this.load();
        }

        await this.#initPromise;

        console.log('PATC', 'opening ');


        if (this.message) {
            let messageElem = document.createElement('div');
            messageElem.classList.add('patcm__message');
            messageElem.innerText = this.message;

            this.container.querySelector('.patcm__product-title').after(messageElem);

        }

        this.container.classList.add('open');


        // Delay to avoid catching the click that triggered open
        setTimeout(() => {
            document.addEventListener('click', this.#handleOutsideClick);
            document.addEventListener('keydown', this.#handleKeydown);
            document.addEventListener('keydown', this.#trapFocus);

            // Optionally focus first element inside cart 
            /* TODO UPDATE
            const firstFocusable = this.container.querySelector(
                'a[href], button:not([disabled]), textarea, input, select, [tabindex]:not([tabindex="-1"])'
            );
            firstFocusable?.focus(); */
        }, 0);
    }

    close() {
        this.container.classList.remove('open');
        this.container.remove();
        this.ready = false;
        delete this.message;
        document.removeEventListener('click', this.#handleOutsideClick);
        document.removeEventListener('keydown', this.#handleKeydown);
        document.removeEventListener('keydown', this.#trapFocus);
    }

    #handleOutsideClick = (event) => {
        if (!this.inner.contains(event.target)) {
            this.close();
        }
    };

    #handleKeydown = (event) => {
        if (event.key === 'Escape') {
            this.close();
        }
    };

    #trapFocus = (event) => {
        const focusableElements = this.container.querySelectorAll(
            'a[href], button:not([disabled]), textarea, input, select, [tabindex]:not([tabindex="-1"])'
        );
        const first = focusableElements[0];
        const last = focusableElements[focusableElements.length - 1];

        if (event.key !== 'Tab') return;

        if (event.shiftKey) {
            // Shift + Tab
            if (document.activeElement === first) {
                event.preventDefault();
                last.focus();
            }
        } else {
            // Tab
            if (document.activeElement === last) {
                event.preventDefault();
                first.focus();
            }
        }
    };

    #handleCloseClick(e) {
        e.preventDefault();
        this.close();
    }

    #boundHandleCloseClick = this.#handleCloseClick.bind(this)

    #initLayout() {
        this.container.querySelectorAll('[data-role="close-button"]').forEach((elem) => {
            console.log(elem);
            elem.addEventListener('click', this.#boundHandleCloseClick)
        });

        const slider = this.container.querySelector('.patcm__product-recommendations .glide');
        if (slider) {
            const slideshow = new Glide(slider, {
                type: 'carousel',
                gap: 0,
                startAt: 0,
                perView: 5,
                autoplay: false,
                breakpoints: {
                    1200: {
                        perView: 5,
                    },
                    1000: {
                        perView: 4,
                    },
                    768: {
                        perView: 3,
                    },
                    450: {
                        perView: 2,
                    },
                },
            });
            slideshow.mount();
        }
    }
}


const postAddToCartModal = new PostAddToCartModal();


/* -------------------------------------------------------------------------- */
/*                                   Images                                   */
/* -------------------------------------------------------------------------- */

/* -------------------------- Catch Thumbnail Image ------------------------- */
const productImageSection = document.querySelector('.product-page .image-section');
if (productImageSection) {
    const onScroll = () => {
        const elRect = productImageSection.getBoundingClientRect();

        if (productImageSection.classList.contains('caught')) {
            // We are caught, look for release
            if (elRect.top >= 0) {
                productImageSection.style.top = '';
                productImageSection.classList.remove('caught');
            }
        } else {
            // Try to catch
            if (elRect.top < 0) {
                const parentRect = productImageSection.parentElement?.getBoundingClientRect();
                const distanceFromParentTop = elRect.top - parentRect.top;

                productImageSection.style.top = `${distanceFromParentTop}px`;
                productImageSection.classList.add('caught');
            }
        }


    };

    window.addEventListener('scroll', onScroll);
    window.addEventListener('resize', onScroll); // Optional: to handle viewport changes
    onScroll(); // Run once on load
}



/* -------------------------------------------------------------------------- */
/* -------------------------------------------------------------------------- */
/*                               Money formatter                              */
/* -------------------------------------------------------------------------- */
var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = "${{amount}}";
Shopify.formatMoney = function (cents, format) {
    if (typeof cents == 'string') { cents = cents.replace('.', ''); }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || this.money_format);

    function defaultOption(opt, def) {
        return (typeof opt == 'undefined' ? def : opt);
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = defaultOption(precision, 2);
        thousands = defaultOption(thousands, ',');
        decimal = defaultOption(decimal, '.');

        if (isNaN(number) || number == null) { return 0; }

        number = (number / 100.0).toFixed(precision);

        var parts = number.split('.'),
            dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
            cents = parts[1] ? (decimal + parts[1]) : '';

        return dollars + cents;
    }

    switch (formatString.match(placeholderRegex)[1]) {
        case 'amount':
            value = formatWithDelimiters(cents, 2);
            break;
        case 'amount_no_decimals':
            value = formatWithDelimiters(cents, 0);
            break;
        case 'amount_with_comma_separator':
            value = formatWithDelimiters(cents, 2, '.', ',');
            break;
        case 'amount_no_decimals_with_comma_separator':
            value = formatWithDelimiters(cents, 0, '.', ',');
            break;
    }

    return formatString.replace(placeholderRegex, value);
};